import axios from "axios";
import qs from "qs";

// axios.defaults.withCredentials = true

export async function aGet(url, params) {
  try {
    let res = await axios.get(url, {
      params: params,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      timeout: 8000
    });
    return res;
  } catch (e) {
    console.log("e", e);
  }
}

//GET: application/json
export async function aGet2(url, params) {
  try {
    let res = await axios.get(url, {
      params: params,
      headers: { "Content-Type": "application/json" },
      timeout: 8000
    });
    return res;
  } catch (e) {
    console.log(e);
  }
}

//x-www-form-urlencoded
export async function aPost(url, params) {
  try {
    //console.log(url, params);
    let res = await axios.post(url, qs.stringify(params), {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      timeout: 8000
    });
    return res;
  } catch (e) {
    console.log(e);
  }
}

//application/json
export async function aPost2(url, params) {
  try {
    //console.log(url, params);
    let res = await axios.post(url, Object.assign({},params), {
      headers: { "Content-Type": "application/json" },
      timeout: 8000
    });
    return res;
  } catch (e) {
    console.log(e);
  }
}

export async function aPost3(url, params) {
  try {
    axios.defaults.headers.common["sso_sessionid"] = localStorage.getItem(
      "session_id"
    );
    let res = await axios.post(url, params, {
      headers: {
        "Content-Type": "application/json"
      }
    });
    return res;
  } catch (e) {
    console.log(e);
  }
}

export async function aPost4(url, params) {
  try {
    //console.log(url, params);
    let res = await axios.post(url, qs.stringify(params), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        sso_sessionid: localStorage.getItem("session_id")
      },
      timeout: 8000
    });
    return res;
  } catch (e) {
    console.log(e);
  }
}
